import { FieldNormalizer } from '../types';

export default class ObjectFieldNormalizer implements FieldNormalizer {
  normalize(value: any): ObjectFieldValue {
    return {
      id: Number(value?.id || value),
      type: 'object',
    };
  }

  reverseNormalize(value: ObjectFieldValue) {
    return String(value?.id) || '';
  }
}

export interface ObjectFieldValue {
  id: number;
  type: 'object';
}
